module.exports = __webpack_public_path__ + "i18n/ko_be1f666e46361bb2b92ab96ba8e72182.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_ko.properties
// module id = aSTO
// module chunks = 51